import React, { useState, useEffect } from 'react';
import { IonContent, IonText, IonButton } from '@ionic/react';

// Generate a list of 100 items with unique emojis and random prices
const generateItems = () => {
    const emojiItems = [
        '🍎', '🍌', '🍇', '🍊', '🥛', '🍞', '🍕', '🍔', '🍟', '🌮',
        '🥗', '🍿', '🧃', '🥜', '🍫', '🍩', '🧀', '🥩', '🍗', '🥓',
        '🍣', '🍤', '🥞', '🧈', '🍭', '🍪', '🍨', '🍦', '🍾', '🍷',
        '🥃', '🍺', '🍹', '🍵', '☕', '🧊', '🍶', '🥡', '🥢', '🍽',
        '🥄', '🍴', '🥫', '🧂', '🍼', '🍔', '🍟', '🌭', '🥪', '🌯',
        '🥗', '🧆', '🍚', '🍛', '🍜', '🍝', '🍲', '🥘', '🥧', '🧁',
        '🥤', '🍻', '🥂', '🧋', '🍥', '🍢', '🍡', '🍧', '🍛', 
        '🍘', '🍔', '🍟', '🍗', '🥩', '🧀', '🍳', '🍲', '🍜', '🍣',
        '🍤', '🥮', '🍱', '🥖', '🍔', '🍟', '🍹', '🍸', '🥄', '🍴',
        '🥫', '🧃', '🍪', '🥧', '🍦', '🍬', '🍿', '🥜', '🥗', '🍕',
    ];
  
    // Generate random prices between ₹5 and ₹100
    return emojiItems.map((emoji, index) => ({
        name: `${emoji}`,
        price: Math.floor(Math.random() * 96) + 5, // Price between ₹5 and ₹100
    }));
};
  
const items = generateItems();

// Generate a random pair of items for comparison, ensuring unique prices
const generateQuestion = () => {
    const shuffledItems = [...items].sort(() => 0.5 - Math.random());
    const item1 = shuffledItems[0];
    let item2 = shuffledItems[1];
  
    // Ensure the prices are not equal
    while (item1.price === item2.price) {
      item2 = shuffledItems[Math.floor(Math.random() * shuffledItems.length)];
    }
  
    return [item1, item2];
};

const ComparingPrices: React.FC = () => {
    const [questionItems, setQuestionItems] = useState([items[0], items[1]]);
    const [questionType, setQuestionType] = useState<'cheaper' | 'expensive'>('cheaper');
    const [resultMessage, setResultMessage] = useState<string>('');
    const [isCorrect, setIsCorrect] = useState<boolean | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);
    const [correctAnswer, setCorrectAnswer] = useState<string | null>('');
    const [userOption, setUserOption] = useState<string | null>('');

    useEffect(() => {
        generateNewQuestion();
        document.title = "Mamas Guidance - Class Two - Mathematics - Money - Comparing Prices"; // Set page title
    }, []);

    const generateNewQuestion = () => {
        const newQuestionItems = generateQuestion();
        const randomType = Math.random() > 0.5 ? 'cheaper' : 'expensive';
        setQuestionItems(newQuestionItems);
        setQuestionType(randomType);
    };

    const handleSelection = (selectedItem: { name: string; price: number }) => {
        const targetItem =
            questionType === 'cheaper'
                ? questionItems[0].price < questionItems[1].price
                ? questionItems[0]
                : questionItems[1]
                : questionItems[0].price > questionItems[1].price
                ? questionItems[0]
                    : questionItems[1];
        setCorrectAnswer(targetItem.name);
        setUserOption(selectedItem.name);

        if (selectedItem.name === targetItem.name) {
            setShowImage(true);
            setTimeout(() => {
                generateNewQuestion();
                setShowImage(false);
                setError(false);
            }, 5000);
        } else {
            setError(true);
        }
    };

    return (
        <>
            {
                showImage === false ?
                <>
                        <div className='contentPart showCenter additionWord' style={{ padding: 0, paddingBottom: '10%'}}>
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                            <div>   
                                <p>Choose the <strong>{questionType === 'cheaper' ? 'cheaper' : 'more expensive'}</strong> item:</p>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', gap: '20px' }}>
                            {questionItems.map((item, index) => (
                                <div key={index} style={{ textAlign: 'center' }}>
                                    <IonText>
                                        <h3>Item {index+1 } {item.name}</h3>
                                        <p>₹{item.price}</p>
                                    </IonText>
                                </div>
                            ))}
                            </div>

                            <div className='optionDiv' style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                {questionItems.map((item, index) => (
                                    <div
                                        className={`optionButton ${
                                            userOption === item.name
                                                ? item.name === correctAnswer
                                                    ? 'correct'
                                                    : 'incorrect'
                                                : ''
                                        }`}
                                        key={index} onClick={() => handleSelection(item)}>
                                    {item.name} (₹{item.price})
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </>
                :
                <>
                    <div className="contentPart showMiddle">
                        <img style={{height: '150px'}} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                    </div>
                </>
            }
        </>
    );
};

export default ComparingPrices;
